import React from "react";
import PropTypes from "prop-types";
import { Table, Header, Label } from "semantic-ui-react";

const RecommendationRow = ({
  recommendation,
  activeFilterPrimary,
  activeFilterSecondary,
  dotNotation,
  dotNotationExists
}) => {
  const {
    recommendationId,
    recommendationText,
    recommendationNumber,
    findingNumber,
    category,
    auditName,
    department,
    status,
    update,
    issueDate,
    auditURL,
    findingText,
    auditType
  } = recommendation;

  let recommendationNumberDisplay = recommendationNumber;
  if (dotNotation === true && findingNumber > 0) {
    recommendationNumberDisplay = `${findingNumber}.${recommendationNumber}`;
  }

  let dateString = "";
  if (issueDate && issueDate.length > 1) {
    const dateTime = new Date(issueDate);
    const dateMonth = dateTime.getMonth() + 1;
    const dateYear = dateTime.getFullYear();
    dateString = `${dateMonth}/${dateYear}`;
  }

  const hasAuditURL = auditURL && auditURL.length > 1;

  return (
    <Table.Row key={recommendationId}>
      <Table.Cell
        className="break-word-narrow"
        positive={
          activeFilterPrimary === "auditName" ||
          activeFilterSecondary === "auditName"
        }
      >
        <Header style={{ fontSize: "14px" }}>
          <Header.Content>
            <span>
              {hasAuditURL && (
                <a
                  href={auditURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`View ${auditName} report (opens in a new window)`}
                  style={{
                    color: "#1D76B9",
                    fontWeight: "bold"
                  }}
                >
                  {auditName}
                </a>
              )}
              {!hasAuditURL && auditName}
              {auditType === "investigation" && (
                <span>
                  <Label color="violet" size="small">
                    Investigation
                  </Label>
                </span>
              )}
            </span>
            <Header.Subheader
              style={{ whiteSpace: "pre-line", fontSize: "13px" }}
            >
              {findingText}
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Table.Cell>
      {dotNotationExists && (
        <Table.Cell
          style={{
            whiteSpace: "pre-line"
          }}
        >
          {recommendationNumberDisplay}
        </Table.Cell>
      )}
      <Table.Cell
        className="break-word-narrow"
        style={{
          overflow: "hidden",
          whiteSpace: "pre-line"
        }}
      >
        {recommendationText}
      </Table.Cell>
      <Table.Cell
        className="break-word-narrow"
        style={{
          overflow: "hidden",
          whiteSpace: "pre-line"
        }}
      >
        {update}
      </Table.Cell>
      <Table.Cell
        className="break-word-narrow"
        width="2"
        positive={
          activeFilterPrimary === "status" || activeFilterSecondary === "status"
        }
      >
        {status}
      </Table.Cell>
      <Table.Cell
        width="1"
        positive={
          activeFilterPrimary === "year" || activeFilterSecondary === "year"
        }
      >
        {dateString}
      </Table.Cell>
      <Table.Cell
        className="break-word-narrow"
        positive={
          activeFilterPrimary === "department" ||
          activeFilterSecondary === "department"
        }
      >
        {department}
      </Table.Cell>
      <Table.Cell
        className="break-word-narrow"
        positive={
          activeFilterPrimary === "category" ||
          activeFilterSecondary === "category"
        }
      >
        {category}
      </Table.Cell>
    </Table.Row>
  );
};

RecommendationRow.propTypes = {
  recommendation: PropTypes.shape({
    recommendationId: PropTypes.string.isRequired,
    recommendationText: PropTypes.string.isRequired,
    recommendationNumber: PropTypes.number.isRequired,
    findingNumber: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    auditName: PropTypes.string.isRequired,
    department: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    update: PropTypes.string.isRequired,
    issueDate: PropTypes.string,
    auditURL: PropTypes.string,
    findingText: PropTypes.string.isRequired,
    auditType: PropTypes.string.isRequired
  }).isRequired,
  activeFilterPrimary: PropTypes.string,
  activeFilterSecondary: PropTypes.string,
  dotNotation: PropTypes.bool,
  dotNotationExists: PropTypes.bool.isRequired
};

RecommendationRow.defaultProps = {
  activeFilterPrimary: null,
  activeFilterSecondary: null,
  dotNotation: false
};

export default RecommendationRow;
